import { computed } from 'vue';

import { TEntity } from '@/types';
import tt from '@/i18n/utils/translateText';
import { checkFeatureIsEnabled } from '@/domains/checkFeatureIsEnabled';
import { EExperimentalFeatures } from '@/domains/constants';

export enum EVatRate {
  vat_20 = 'vat_20',
  vat_0 = 'vat_0',
  vat_none = 'vat_none',
}

// после выпила фф vatRatesV2 переименовать в EVatRate, а верхний удалить
export enum EVatRateV2 {
  vat_20 = 'vat_20',
  vat_10 = 'vat_10',
  vat_7 = 'vat_7',
  vat_5 = 'vat_5',
  vat_0 = 'vat_0',
  vat_none = 'vat_none',
}

export const VAT_RATE_V2_TRANSLATION = computed(() => ({
  [EVatRateV2.vat_20]: `${tt('shared.vat')} 20%`,
  [EVatRateV2.vat_10]: `${tt('shared.vat')} 10%`,
  [EVatRateV2.vat_7]: `${tt('shared.vat')} 7%`,
  [EVatRateV2.vat_5]: `${tt('shared.vat')} 5%`,
  [EVatRateV2.vat_0]: `${tt('shared.vat')} 0%`,
  [EVatRateV2.vat_none]: tt('shared.vatRate.vatNone'),
}));

export const VAT_RATE_V2_TRANSLATION_SHORT = computed(() => ({
  [EVatRateV2.vat_20]: '20%',
  [EVatRateV2.vat_10]: '10%',
  [EVatRateV2.vat_7]: '7%',
  [EVatRateV2.vat_5]: '5%',
  [EVatRateV2.vat_0]: '0%',
  [EVatRateV2.vat_none]: tt('shared.vatRate.vatNone'),
}));

export const VAT_RATE_TRANSLATION = {
  [EVatRate.vat_20]: tt('shared.vatRate.vat20'),
  [EVatRate.vat_0]: tt('shared.vatRate.vat0'),
  [EVatRate.vat_none]: tt('shared.vatRate.vatNone'),
};

export const VAT_RATE_TRANSLATION_SHORT = {
  [EVatRate.vat_20]: '20%',
  [EVatRate.vat_0]: '0%',
  [EVatRate.vat_none]: tt('shared.vatRate.vatNone'),
};

const getVatRateOptions = (): TEntity[] => {
  if (checkFeatureIsEnabled(EExperimentalFeatures.vatRatesV2)) {
    return Object.values(EVatRateV2).map((item: EVatRateV2) => ({
      id: item,
      name: VAT_RATE_V2_TRANSLATION_SHORT.value[item],
    }));
  }

  return Object.values(EVatRate).map((item: EVatRate) => ({
    id: item,
    name: VAT_RATE_TRANSLATION[item],
  }));
};

export default getVatRateOptions;
